module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.tableStyle)
  }, [(!_vm.fixedHeader) ? _vm._t("header") : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (!_vm.fixedFooter) ? _vm._t("footer") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dbe74b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VTable/index.vue
// module id = 1795
// module chunks = 1